/**
 * User: nir
 *
 * A small script that collapses containers to a specified height and adds a toggle button to collapse and un-collapse
 * them.
 *
 * Date: 06/10/2016
 * Time: 12:06
 */

if (window['jQuery']) {
    window.jQuery(function ($) {
        var containers = $('[data-collapse]');
        if (!containers || !containers.length) return;

        containers.each(function (i, e) {
            var container = $(e).css('overflow', 'hidden'),
                designatedHeight = parseInt(container.data('collapse')),
                maxHeight = container.height();

            if (maxHeight > designatedHeight * 1.1) {
                var opened = true,
                    button = $('<a />').addClass('waves-effect').on('click', toggle),
                    attached = false;

                function toggle(ev) {
                    if (ev && ev.preventDefault) ev.preventDefault();

                    if (opened) {
                        // close
                        container.animate({height: designatedHeight}, 'fast');
                        button.text('Show More');
                        opened = false;
                    } else {
                        container.animate({height: maxHeight}, 'fast');
                        button.text('Show Less');
                        opened = true;
                    }

                    if (!attached) {
                        button.insertAfter(container);
                        attached = true;
                    }

                    return false;
                }

                toggle();
            }
        });
    });
}